<template>
  <div class="canWeDo_box">
    <div class="canWeDo_warpper">
      <div
          v-for="(item, index) in functionIntroduction"
          :key="index"
          class="canWeDo_warpper_card"
          @mouseenter="startFlip(index)"
          @mouseleave="startUnflip(index)"
          :style="{ transform: cardTransforms[index] }"
      >
        <div class="card-face card-front">
          <div class="canWeDo_warpper_card_title">{{ item.title }}</div>
          <div class="canWeDo_warpper_card_img">
            <img :src="functionIntroductionImg" alt="" />
          </div>
          <div class="canWeDo_warpper_card_content">
            <p>{{ truncateText(item.Introduction, 50) }}</p>
          </div>
        </div>
        <div class="card-face card-back">
          <div class="card-back-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.Introduction }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    functionIntroduction: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      functionIntroductionImg: require('@/assets/recycling/index/supplyChain.svg'),
      cardTransforms: [],
      flipTimeouts: []
    };
  },
  created() {
    // 初始化卡片transform状态
    this.cardTransforms = new Array(this.functionIntroduction.length).fill('rotateY(0deg)');
    this.flipTimeouts = new Array(this.functionIntroduction.length).fill(null);
  },
  methods: {
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    startFlip(index) {
      // 清除之前的未完成动画
      if (this.flipTimeouts[index]) {
        clearTimeout(this.flipTimeouts[index]);
      }
      this.$set(this.cardTransforms, index, 'rotateY(180deg)');
    },
    startUnflip(index) {
      // 设置延迟以确保动画完整
      this.flipTimeouts[index] = setTimeout(() => {
        this.$set(this.cardTransforms, index, 'rotateY(0deg)');
      }, 100); // 100ms延迟确保动画流畅
    }
  }
};
</script>

<style scoped>
.canWeDo_box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.canWeDo_warpper {
  width: 1400px;
  height: 768px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  perspective: 1000px;
}

.canWeDo_warpper_card {
  position: relative;
  width: 330px;
  height: 369px;
  border-radius: 8px;
  cursor: pointer;
  transform-style: preserve-3d;
  transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.card-face {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px rgba(143, 143, 143, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.card-front {
  z-index: 2;
}

.card-back {
  transform: rotateY(180deg);
  background-color: rgba(26, 190, 107, 1);
  color: white;
  justify-content: center;
}

.canWeDo_warpper_card_title,
.canWeDo_warpper_card_img,
.canWeDo_warpper_card_content {
  width: 100%;
  display: flex;
  justify-content: center;
}

.canWeDo_warpper_card_title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 28.96px;
  color: rgba(0, 0, 0, 1);
  margin-top: 30px;
}

.canWeDo_warpper_card_img {
  margin-top: 20px;
}

.canWeDo_warpper_card_content {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 20.27px;
  color: rgba(51, 51, 51, 1);
}

.canWeDo_warpper_card_content p {
  margin: 0 30px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.card-back-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
}

.card-back-content h3 {
  font-size: 22px;
  margin-bottom: 20px;
  text-align: center;
}

.card-back-content p {
  font-size: 16px;
  line-height: 1.6;
}
</style>
